import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { TASA_INTERES_PORCENTAJE } from '../../../core/constants/globals';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterModule, LazyLoadImageModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit {
  porcentaje_tasa = TASA_INTERES_PORCENTAJE;
  backgroundImage =
    'https://d2kkzfskpa3qm4.cloudfront.net/imagenes/bg-page.webp';
  constructor() {}

  ngOnInit() {}
}
